import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { ucFirst } from "../../Common/js/generic_functions"

class PlantsPeriodsGraph extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.dMgr.debug("this.props.plants.length :", this.props.plants.length)

    if (this.props.plants.length > 1) {
      this.onePlantDisplay = false
      this.decalName = 100
      this.colorBackground = "rgba(0, 0, 0, 5)"
      this.canvaId = "plantsCanvas_multi_" + this.props.plants.length
    } else {
      this.onePlantDisplay = true
      this.decalName = 0
      this.colorBackground = "rgba(0, 0, 0, 0.5)"
      this.canvaId = "plantsCanvas_one_" + this.props.plants[0].id
    }

    this.decal = 30
    this.decalMonths = 40
    this.decalLegend = 0
    this.canvasWindowWidth = this.props.canvasWindowWidth || 700

    this.canvasWidth = this.canvasWindowWidth - this.decalName
    this.periods = ["Jan", "", "Fév", "", "Mar", "", "Avr", "", "Mai", "", "Juin", "", "Juil", "", "Août", "", "Sep", "", "Oct", "", "Nov", "", "Déc", ""]
    this.periodWidth = (this.canvasWindowWidth - this.decalName - this.decal) / this.periods.length

    this.colorSeedGlass = "rgba(0, 128, 255, 0.8)"
    this.colorSeedSoil = "rgba(0, 200, 0, 0.81)"
    this.colorPlanting = "rgba(255, 166, 0, 0.88)"
    this.colorFlowaring = "rgba(255, 0, 170, 0.82)"
    this.colorHarvesting = "rgba(174, 0, 255, 0.82)"
    this.colorText = "rgb(255, 255, 255)"
    this.colorToday = "rgba(255, 0, 0, 0.82)"
    this.colorVerticalLinePeriod = "rgba(85, 52, 168, 0.53)"
    this.textFont = "14px Arial"
    this.textSmallFont = "10px Arial"
    this.colorStripped = "rgba(87, 60, 100, 0.5)"
  }

  getSortedPlants() {
    return [...this.props.plants].sort((a, b) => a.name.localeCompare(b.name))
  }

  getCanvasHeight() {
    return this.getSortedPlants().reduce((height, plant) => {
      return height + this.getPlantHeight(plant)
    }, this.decalMonths + this.decalLegend)
  }

  getPlantHeight(plant) {
    const totalPeriods = (plant.periodSeedGlass?.length || 0) + (plant.periodSeedSoil?.length || 0) + (plant.periodPlanting?.length || 0) +(plant.periodFlowering?.length || 0) + (plant.periodHarvesting?.length || 0)

    return totalPeriods > 0 ? 10 * totalPeriods + 20 : 30
  }

  componentDidMount() {
    this.drawCanvas()
  }

  componentDidUpdate() {
    this.drawCanvas()
  }

  drawCanvas() {
    const canvas = document.getElementById(this.canvaId)
    if (!canvas) return
    const ctx = canvas.getContext("2d")
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    ctx.fillStyle = this.colorBackground
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    this.drawScale(ctx)
    this.drawHorizontalZones(ctx)
    this.drawPlantNamesAndPeriods(ctx)
    this.drawCurrentDay(ctx)
  }

  // 1️⃣ Ajout des lignes verticales et des noms des mois
  drawScale(ctx) {
    ctx.fillStyle = this.colorText
    ctx.strokeStyle = this.colorVerticalLinePeriod
    ctx.font = this.textFont

    this.periods.forEach((period, i) => {
      const x = i * this.periodWidth + this.decal + this.decalName
      const isMonthStart = i % 2 === 0

      if (isMonthStart && period) {
        ctx.fillText(period, x - 10, 10)
      }

      if (this.props.displayPeriodNumbers) {
        ctx.fillText(i + 1, x - 5, 25)
      }

      ctx.beginPath()
      ctx.moveTo(x, 30)
      ctx.lineTo(x, this.getCanvasHeight())
      ctx.lineWidth = isMonthStart ? 2 : 1
      ctx.stroke()
    })
  }

  // 2️⃣ Création des zones horizontales avec transparence
  drawHorizontalZones(ctx) {
    let yBase = this.decalMonths + this.decalLegend

    this.getSortedPlants().forEach((plant, index) => {
      const plantHeight = this.getPlantHeight(plant)

      if (index % 2 === 1) {
        ctx.fillStyle = this.colorStripped
        ctx.fillRect(0, yBase, this.canvasWindowWidth, plantHeight)
      }

      yBase += plantHeight
    })
  }

  // 3️⃣ Ajout des noms des plantes et affichage des périodes
  drawPlantNamesAndPeriods(ctx) {
    let yBase = this.decalMonths + this.decalLegend
    const decal = 10

    this.getSortedPlants().forEach((plant) => {
      const plantHeight = this.getPlantHeight(plant)

      if (!this.onePlantDisplay) {
        // Centrage vertical du nom de la plante
        const textY = yBase + plantHeight / 2 + 4
        ctx.fillStyle = this.colorText
        ctx.font = this.textFont
        ctx.fillText(ucFirst(plant.name), 10, textY)
      }

      const periods = [
        { data: plant.periodSeedGlass, color: this.colorSeedGlass, text: "Serre" },
        { data: plant.periodSeedSoil, color: this.colorSeedSoil, text: "Pleine terre" },
        { data: plant.periodPlanting, color: this.colorPlanting, text: "Plantation" },
        { data: plant.periodFlowering, color: this.colorFlowaring, text: "Floraison" },
        { data: plant.periodHarvesting, color: this.colorHarvesting, text: "Récolte" },
      ]

      let periodY = yBase + (plantHeight - periods.filter((p) => p.data?.length).length * decal) / 2

      periods.forEach(({ data, color, text }) => {
        if (data?.length) {
          this.drawPeriod(ctx, data, periodY, color, text)
          periodY += decal
        }
      })

      yBase += plantHeight
    })
  }

  drawPeriod(ctx, periodRange, y, color, text) {
    ctx.fillStyle = color

    periodRange.forEach((range) => {
      const [start, end] = range.split("|").map(Number)
      const xStart = (start - 1) * this.periodWidth + this.decal + this.decalName
      const xEnd = (end - 1) * this.periodWidth + this.decal + this.decalName
      ctx.fillRect(xStart, y, xEnd - xStart, 8)

      ctx.font = this.textSmallFont
      ctx.fillText(text, xStart, y - 1)
    })
  }

  drawCurrentDay(ctx) {
    let date = new Date()

    let currentDay = date.getDate()
    let currentMonth = date.getMonth()

    if (currentDay <= 1) {
      currentDay = 0
    } else if (currentDay > 29) {
      currentDay = 29
    }

    let x = currentMonth * 2 * this.periodWidth + (currentDay * this.periodWidth * 2) / 30 + this.decal + this.decalName

    ctx.strokeStyle = this.colorToday
    ctx.beginPath()
    ctx.moveTo(x, 20)
    ctx.lineTo(x, this.getCanvasHeight())
    ctx.lineWidth = 1
    ctx.stroke()
  }

  render() {
    this.dMgr.rendering()
    const canvasHeight = this.getCanvasHeight()

    return <canvas key={this.canvaId} id={this.canvaId} width={this.canvasWindowWidth} height={canvasHeight} />
  }
}

export default withHooks(PlantsPeriodsGraph)
